import { jsx as r } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import l from "@mui/material/ToggleButtonGroup";
import u from "styled-components";
const p = {
  root: "toggleButtonGroupRoot",
  grouped: "toggleGrouped",
  vertical: "toggleVertical"
}, n = u(l).withConfig({
  displayName: "StyledToggleButtonGroup"
})([
  "&&.toggleButtonGroupRoot{padding:4px;border:1px solid ",
  ";}&&.toggleButtonGroupRoot .toggleButtonRoot{border-radius:4px;}&&.toggleButtonGroupRoot .toggleButtonRoot + .toggleButtonRoot{box-shadow:none;margin-top:0px;margin-left:4px;}&&.toggleButtonGroupRoot.toggleVertical .toggleButtonRoot + .toggleButtonRoot{margin-top:4px;margin-left:0px;}"
], ({ theme: o }) => o.primaryBorder), a = /* @__PURE__ */ e(({ classes: o, ...t }, g) => /* @__PURE__ */ r(n, {
  ...t,
  ref: g,
  classes: {
    ...p,
    ...o
  }
}));
a.displayName = "ToggleButtonGroup";
export {
  a as default
};
